import React from 'react';
import PropTypes from 'prop-types';
import {useHistory, useLocation} from 'react-router-dom';
import queryString from 'query-string';

import TableText from "components/TableText";
import { useInventoryNavigation } from 'contexts/InventoryNavigationContext';

const ItemTableLink = ({item, accessor, ...props}) => {
  const history = useHistory();
  const location = useLocation();
  const { saveFilters } = useInventoryNavigation();

  const goToItemDetail = () => {
    const currentFilters = queryString.parse(location.search);
    saveFilters(currentFilters);
    
    history.push(`/inventory/items/detail/${item._id}`);
  }

  return (
    <TableText
      item={item}
      accessor={accessor}
      style={{ cursor: "pointer" }}
      onClick={goToItemDetail}
      {...props}
    />
  );
};

ItemTableLink.propTypes = {
  item: PropTypes.object.isRequired
};

export default ItemTableLink;
